export default __webpack_public_path__ + "locales/sl/SocialAuthWelcomeDialog.json?hash=3a936c56f9b74426a185ced941ca1ad4";